var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "new" } },
    [
      _c("div", [
        _c("p", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.adblock,
              expression: "adblock"
            }
          ],
          staticClass: "has-text-danger",
          domProps: { innerHTML: _vm._s(_vm.$t("message.adblock")) }
        }),
        _vm._v(" "),
        _c("br")
      ]),
      _vm._v(" "),
      _c(
        "vue-dropzone",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isError && !_vm.adblock,
              expression: "!isError && !adblock"
            }
          ],
          ref: "myVueDropzone",
          attrs: {
            id: "dropzone",
            options: _vm.dropzoneOptions,
            useCustomSlot: true,
            "use-custom-dropzone-options": true
          },
          on: { "vdropzone-sending": _vm.sendingEvent }
        },
        [
          _c("div", { staticClass: "dropzone-custom-content" }, [
            _c("img", {
              attrs: {
                src: "/static/images/upload.svg",
                width: "48",
                alt: "アップローダー"
              }
            }),
            _vm._v(" "),
            _c("h3", { staticClass: "title" }, [_vm._v("Drag and drop")]),
            _vm._v(" "),
            _c("div", { staticClass: "subtitle" }, [_vm._v("or click here!")]),
            _vm._v(" "),
            _c("div", { staticClass: "subtitle" }, [
              _vm._v(_vm._s(_vm.$t("message.top.subtitle")))
            ])
          ]),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "csrf_token" },
            domProps: { value: _vm.csrfToken }
          })
        ]
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("div", { staticClass: "tile is-ancestor" }, [
        _c("div", { staticClass: "tile is-parent" }, [
          _c("article", { staticClass: "tile is-child box" }, [
            _c("p", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("message.top.title.1")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c(
                "p",
                [
                  _vm._v(_vm._s(_vm.$t("message.top.content.1_1"))),
                  _c("router-link", { attrs: { to: "/signup" } }, [
                    _vm._v(_vm._s(_vm.$t("message.top.content.1_2")))
                  ]),
                  _vm._v(_vm._s(_vm.$t("message.top.content.1_3")))
                ],
                1
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tile is-parent" }, [
          _c("article", { staticClass: "tile is-child box" }, [
            _c("p", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("message.top.title.2")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("p", [_vm._v(_vm._s(_vm.$t("message.top.content.2")))])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tile is-ancestor" }, [
        _c("div", { staticClass: "tile is-parent" }, [
          _c("article", { staticClass: "tile is-child box" }, [
            _c("p", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("message.top.title.3")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("p", [_vm._v(_vm._s(_vm.$t("message.top.content.3")))])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tile is-parent" }, [
          _c("article", { staticClass: "tile is-child box" }, [
            _c("p", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("message.top.title.4")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c(
                "p",
                [
                  _vm._v(_vm._s(_vm.$t("message.top.content.4_1"))),
                  _c("router-link", { attrs: { to: "/subscription" } }, [
                    _vm._v(_vm._s(_vm.$t("message.top.content.4_2")))
                  ]),
                  _vm._v(_vm._s(_vm.$t("message.top.content.4_3")))
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("modal", { attrs: { name: "is_uploading", adaptive: "" } }, [
        _c("div", { staticClass: "uploading has-text-centered" }, [
          _c("h2", [_vm._v(_vm._s(_vm.$t("message.top.uploading")))]),
          _vm._v(" "),
          _c("div", { staticClass: "lds-roller" }, [
            _c("div"),
            _c("div"),
            _c("div"),
            _c("div"),
            _c("div"),
            _c("div"),
            _c("div"),
            _c("div")
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8ab79656", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ab79656","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Top.vue
// module id = null
// module chunks = 